import * as type from '../actions/types';

const initialState = {
  fetching: false,
  data: [],
  error: false,
  errorMessage: '',
  success: false,
  shouldFetch: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_HOLIDAY_HOURS_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        shouldFetch: false,
      };
    case type.FETCH_HOLIDAY_HOURS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: {
          ...state?.data,
          hours: action.payload?.data,
        },
        error: false,
        errorMessage: '',
        success: true,
        shouldFetch: false,
      };
    case type.FETCH_HOLIDAY_HOURS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};
